<template>
	<div class="shape-style-editor style-editor-layout" no-gutters>
		<div class="dropdown-top">
			<div class="close-icon"></div>
		</div>

		<div class="dropdown-section">
			<div class="dropdown-section-title">Background Color</div>
			<ColorPicker
				title="Background Color"
				:color.sync="backgroundColor"
				:iconName="'background-sample-icon'"
				:enableTransparent="true"
				:disabled="readonly"
			/>
		</div>
		<div class="dropdown-section">
			<div class="dropdown-section-title">Border Color</div>
			<ColorPicker
				title="Border Color"
				:color.sync="borderColor"
				:iconName="'background-sample-icon'"
				:enableTransparent="true"
				:disabled="readonly"
			/>
		</div>
		<div class="dropdown-section" :class="{ disabled: readonly }">
			<div class="dropdown-section-title">Size</div>
			<div class="dropdown-section-values">
				<InputSlider :value="width" @onChange="(v) => (width = v)" :options="{ min: 25, max: 150 }"></InputSlider>
				<div class="size-display">{{ width }}px</div>
			</div>
		</div>
		<div class="dropdown-section" :class="{ disabled: cornerRadiusDisabled || readonly }">
			<div class="dropdown-section-title">Corner radius</div>
			<div class="dropdown-section-values">
				<InputSlider :value="borderRadius" @onChange="(v) => (borderRadius = v)" :options="{ min: 0, max: 50 }"></InputSlider>
				<div class="size-display">{{ borderRadius }}px</div>
			</div>
		</div>
	</div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker/ColorPicker';
import InputSlider from '@/components/common/InputSlider';

const isTransparent = (color) => ['transparent', '#00000000'].includes(color);

export default {
	name: 'ShapeStyleEditor',
	components: {
		ColorPicker,
		InputSlider,
	},
	props: {
		btnSettings: { type: Object },
		restrictions: { type: Object },
		readonly: { type: Boolean, default: false },
	},
	computed: {
		backgroundColor: {
			set(value) {
				this.updateBtnSettings({ ...this.btnSettings, backgroundColor: value });
			},
			get() {
				return this.btnSettings.backgroundColor;
			},
		},
		borderColor: {
			set(value) {
				this.updateBtnSettings({ ...this.btnSettings, borderColor: value });
			},
			get() {
				return this.btnSettings.borderColor;
			},
		},
		width: {
			set(value) {
				this.updateBtnSettings({ ...this.btnSettings, width: value });
			},
			get() {
				return Number(this.btnSettings.width);
			},
		},
		borderRadius: {
			set(value) {
				this.updateBtnSettings({ ...this.btnSettings, borderRadius: value });
			},
			get() {
				return this.btnSettings.borderRadius;
			},
		},
		cornerRadiusDisabled() {
			return isTransparent(this.backgroundColor) && isTransparent(this.borderColor);
		},
	},
	methods: {
		updateBtnSettings(value) {
			this.$emit('update:btnSettings', value);
		},
	},
};
</script>
<style scoped lang="scss">
.shape-style-editor {
	.size-display {
		width: 60px;
		margin: 0 0 0 9px;
		padding: 0 9px;
		text-align: center;
		background-color: var(--bg-color);
		border: var(--primary-border);
		border-radius: var(--border-radius);
		font-size: 12px;

		.dropdown-section {
			display: flex;
		}
	}
	.dropdown-section {
		&.disabled {
			opacity: 0.4;
			pointer-events: none;
		}
	}
}
</style>
~
